import Button from "../../components/UI/Button";

const SocialFormButton = ({openModal}) => {
  return(
    <Button text={"Add Social Media"} onClickHandler={openModal} />
  )
}

export default SocialFormButton;